<template>
    <div class="info-tags">
        <div class="tag-item" v-for="(tag,index) in tagList" :key="index">
            {{tag}}
        </div>
    </div>
</template>
<script>
export default {
  name: "backindex",
  props: {
    tags: String
  },
  data: function() {
    return {
      tagList: []
    };
  },
  mounted: function() {
    if (this.tags && this.tags != "") {
      this.tagList = this.tags.split(",");
    }
  }
};
</script>
<style>
.info-tags {
  width: 100%;
}
.tag-item {
  font-size: 0.2rem;
  color: #666666;
  border: 0.01rem solid #666666;
  border-radius: 0.08rem;
  float: right;
  padding: 0.06rem 0.1rem;
  margin-left: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/common/tags.vue